import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65c42a50"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip ws_mb4" }, " 属性一般是指设备的运行状态，如当前温度等；方法是指设备可 被调用的方法，支持定义参数，如执行某项任务；事件则是指设 备上报的通知，如告警，需要被及时处理。 ", -1))
const _hoisted_2 = { class: "ws_drawer_footer" }

import { ref, nextTick, watch } from 'vue'
import { cloneDeep, isEmpty } from 'lodash'
import PropertiesForm from './properties-form.vue'
import EventsForm from './events-form.vue'
import ActionsForm from './actions-form.vue'
import { deviceThingInfoAdd, deviceThingInfoUpdate } from '@/api'
import { CODE_ENUM, MODEL_TYPE } from '@/common'
import { useRouter, useRoute } from 'vue-router'
import { useModelStore } from '@/stores/model'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'model-form-drawer',
  props: ['visible', 'data'],
  emits: ['update:visible', 'on-success'],
  setup(__props, { emit: __emit }) {

const modelStore = useModelStore()
modelStore.queryUnitList()
const $route = useRoute()

const thingModelId = $route.query.id || ''

const props = __props
const $emit = __emit

const propertiesFormRef = ref()
const actionFormRef = ref()
const eventFormRef = ref()

const initForm = () => {
  const formRef = getRef()
  formRef.value.initForm(props.data)
}

const getRef = () => {
  return active.value === MODEL_TYPE.PROPERTIES
    ? propertiesFormRef
    : active.value === MODEL_TYPE.ACTIONS
    ? actionFormRef
    : eventFormRef
}

const active = ref(MODEL_TYPE.PROPERTIES)

watch(
  () => props.visible,
  () => {
    if (props.visible && props.data.id) {
      const { thingType } = props.data
      active.value = thingType
      nextTick(initForm)
    }
  }
)

const submit = async () => {
  const formRef = getRef()
  const data = await formRef.value.submit()

  handleAPI(data)
}

const loading = ref(false)
const handleAPI = async (params: any) => {
  loading.value = true
  const fn = props.data.id ? deviceThingInfoUpdate : deviceThingInfoAdd
  const res: any = await fn({
    ...params,
    thingModelId: Number(thingModelId),
    thingType: active.value,
    id: props.data.id,
  }).finally(() => {
    loading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    handleClose()
    ElMessage.success('操作成功')
    $emit('on-success')
  }
}

const handleClose = () => {
  $emit('update:visible', false)
  active.value = MODEL_TYPE.PROPERTIES
}

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    "destroy-on-close": "",
    title: props.data.id ? '编辑物模型' : '新增物模型',
    size: "480px",
    "before-close": handleClose,
    "label-position": "left"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, {
          loading: loading.value,
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, {
          onClick: handleClose,
          plain: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 取消 ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_el_tabs, {
          modelValue: active.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
          class: "tabs ws_mb20"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "属性",
              name: _unref(MODEL_TYPE).PROPERTIES
            }, {
              default: _withCtx(() => [
                _createVNode(PropertiesForm, {
                  ref_key: "propertiesFormRef",
                  ref: propertiesFormRef
                }, null, 512)
              ]),
              _: 1
            }, 8, ["name"]),
            _createVNode(_component_el_tab_pane, {
              label: "方法",
              name: _unref(MODEL_TYPE).ACTIONS
            }, {
              default: _withCtx(() => [
                _createVNode(ActionsForm, {
                  ref_key: "actionFormRef",
                  ref: actionFormRef
                }, null, 512)
              ]),
              _: 1
            }, 8, ["name"]),
            _createVNode(_component_el_tab_pane, {
              label: "事件",
              name: _unref(MODEL_TYPE).EVENTS
            }, {
              default: _withCtx(() => [
                _createVNode(EventsForm, {
                  ref_key: "eventFormRef",
                  ref: eventFormRef
                }, null, 512)
              ]),
              _: 1
            }, 8, ["name"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})